import { toTitleCase } from '@/helpers'

const areas = (rootGetters, state) => {
    if (rootGetters['Auth/isAdmin']) {
        return state.areas
    }

    return state.areas.filter(({ path }) => path !== 'all-areas')
}

const getAttribute = (state, attribute, isAreas = false) => {
    if (state[attribute]) {
        return state[attribute].reduce((acc, attr) => {
            const key = isAreas ? attr.path : attr.toLowerCase()
            const val = isAreas ? attr.name : toTitleCase(attr)
            return { ...acc, [key]: toTitleCase(val) }
        }, {})
    }

    return null
}

const formOptionsAreas = state => getAttribute(state, 'areas', true)
const formOptionsGroups = state => getAttribute(state, 'groups')
const formOptionsCategories = state => getAttribute(state, 'categories')

export default {
    areas,
    formOptionsAreas,
    formOptionsGroups,
    formOptionsCategories
}
